// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.

import type { Range, SemVer } from "./types.ts";
import { testComparatorSet } from "./_test_comparator_set.ts";

/**
 * Test to see if the SemVer satisfies the range.
 *
 * @example Usage
 * ```ts
 * import { parse, parseRange, satisfies } from "@std/semver";
 * import { assert } from "@std/assert";
 *
 * const version = parse("1.2.3");
 * const range0 = parseRange(">=1.0.0 <2.0.0");
 * const range1 = parseRange(">=1.0.0 <1.3.0");
 * const range2 = parseRange(">=1.0.0 <1.2.3");
 *
 * assert(satisfies(version, range0));
 * assert(satisfies(version, range1));
 * assert(!satisfies(version, range2));
 * ```
 * @param version The version to test
 * @param range The range to check
 * @returns true if the version is in the range
 */
export function satisfies(version: SemVer, range: Range): boolean {
  return range.some((set) => testComparatorSet(version, set));
}

// denoCacheMetadata={"headers":{"x-goog-metageneration":"1","x-goog-storage-class":"STANDARD","x-goog-stored-content-length":"945","x-goog-generation":"1725446501945284","x-guploader-uploadid":"AHmUCY0hTtiWT5Eut-vvx7fJ61Ggr0Fk-nFkXLuKI9dgOplXb33ai7zMmlJrOrgDlodWxNZ9gjo","last-modified":"Wed, 04 Sep 2024 10:41:41 GMT","access-control-allow-origin":"*","etag":"\"5dc321eb74eb0d1faeeb957ef14fbde0\"","access-control-expose-headers":"*","server":"UploadServer","cache-control":"public, max-age=31536000, immutable","accept-ranges":"bytes","x-content-type-options":"nosniff","x-jsr-cache-status":"hit","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","x-goog-stored-content-encoding":"identity","x-goog-hash":"crc32c=DGo28g==,md5=XcMh63TrDR+u65V+8U+94A==","content-type":"text/typescript","content-length":"945","cross-origin-resource-policy":"cross-origin","date":"Fri, 08 Nov 2024 09:36:15 GMT","age":"2026","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","via":"1.1 google","x-robots-tag":"noindex","x-jsr-cache-id":"IAD","expires":"Sat, 08 Nov 2025 09:36:15 GMT"},"url":"https://jsr.io/@std/semver/1.0.3/satisfies.ts","time":1731060601}